<template>
    <div class="main-header">
        <div class="container">
            <div class="logo">    
                <img :src="logo" alt="">
            </div>
            <div class="menu">
                <div class="language-container"> 
                  <LanguageChanger v-if="useItineraryStore().allPathsNumber > 0"  uniqueClass="header-lang"></LanguageChanger>
                </div>
                <div v-if="useItineraryStore().showCamera || useItineraryStore().activePoi > 0" class="home-menu-container">
                    <div class="container" @click="resetMap()">
                        <img  v-if="false" class="menu-icon" :src="menuIcon" alt="">
                        <img class="home-icon" :src="homeIcon" alt="">
                    </div>
                </div>  
            </div>
        </div>
    </div>
</template>
<script setup>
import homeIcon  from '@/assets/menu/home-icon.svg';
import menuIcon from '@/assets/menu/menu-icon.svg'; 
import header from '@/components/Header.vue';
import { useItineraryStore } from '@/stores/itinerary-stores.ts'
import LanguageChanger from '@/components/LanguageChanger.vue';
import logo from '@/assets/logo.svg';

function resetMap() {
    console.log("resetMap");
    if(useItineraryStore().activePoi != null) useItineraryStore().activePoi = null;
    useItineraryStore().showCamera = false;
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/styles.scss';
@import '@/assets/styles/mixins.scss';
@import '@/assets/styles/components/header.scss';
</style>